import { Component, EventEmitter, Input, Output } from '@angular/core'
import { RootState } from '@helios/state-management'
import { Store } from '@ngrx/store'

@Component({
  selector: 'hs-filter-modal-controls',
  templateUrl: './filter-modal-controls.component.html',
})
export class FilterModalControlsComponent {
  @Input() filterCount = 0

  @Input() showClearButton = true
  @Input() disableClearButton = true

  @Input() showResetButton = false
  @Input() disableResetButton = true

  @Input() showReloadButton = false

  @Input() showBackButton = false
  @Input() disableBackButton = false

  @Output() openFilterModalEvent = new EventEmitter()
  @Output() clearFiltersEvent = new EventEmitter()
  @Output() resetFiltersEvent = new EventEmitter()
  @Output() reloadTableEvent = new EventEmitter()
  @Output() backEvent = new EventEmitter()

  constructor(private readonly store: Store<RootState>) {}
}
